export class ValidationStatusClientModel {
    constructor(public errorMsg: string , public status: number) {
    }
}
